import { makeStyles, shorthands, tokens } from "@fluentui/react-components";
export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.overflow("hidden"),
  },
  heading: {
    fontFamily: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase500,
    fontStyle: "normal",
    fontWeight: tokens.fontWeightSemibold,
    ...shorthands.padding("8px", "8px", "12px", "8px"),
  },
  listContainer: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.padding("8px"),
    ...shorthands.gap("8px"),
    "@media (min-width: 500px)": {
      ...shorthands.overflow("hidden"),
      scrollbarGutter: "stable",
      "::-webkit-scrollbar": {
        width: "4px",
        height: "4px",
      },
      "::-webkit-scrollbar-thumb": {
        backgroundColor: "#888",
        ...shorthands.borderRadius("4px"),
      },
      "::-webkit-scrollbar-track": {
        backgroundColor: "#ccc",
        ...shorthands.borderRadius("4px"),
      },
      "::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#888",
      },
      "&:hover": {
        overflowY: "scroll",
      },
    },
  },
  infoIcon: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "16px",
    height: "16px",
    ...shorthands.borderRadius("8px"),
    backgroundColor: "#616161",
    color: "white",
    fontSize: "12px",
    flexShrink: 0,
  },
  infoContainer: {
    paddingLeft: "8px",
    paddingRight: "8px",
    ...shorthands.gap("8px"),
    paddingBottom: "8px",
  },
});
